import React from "react";
import { useFormik } from "formik";

const DynamicForm = ({ formFields = [] }) => {
  const formik = useFormik({
    initialValues: formFields?.length
      ? formFields?.reduce((acc, field) => {
          if (field?.hasOwnProperty("value")) {
            acc[field?.["name"]] = field?.["value"] ?? "";
          }
          return acc;
        }, {})
      : {},
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log("Form Values:", values);
    },
  });

  return (
    <div className="dynamicForm" dir={"rtl"}>
      {formFields?.map((field) => {
        return (
          <div key={field?.id} className="fieldWrapper">
            <label htmlFor={field?.name}>{field?.label}:</label>

            {field?.type === "radio" ? (
              field?.options.map((option, index) => (
                <div key={index} className="radioWrapper">
                  <input
                    type="radio"
                    id={`${field?.["name"]}-${option?.["value"]}`}
                    name={field?.["name"]}
                    value={option?.["value"]}
                    checked={
                      formik.values[field?.["name"]] === option?.["value"]
                    }
                    onChange={formik.handleChange}
                    disabled={field?.["readonly"]}
                  />
                  <label htmlFor={`${field?.["name"]}-${option?.["value"]}`}>
                    {option?.["label"]}
                  </label>
                </div>
              ))
            ) : (
              <input
                id={field?.["name"]}
                type={field?.["type"]}
                name={field?.["name"]}
                placeholder={field?.["placeholder"]}
                value={formik.values[field?.["name"]] ?? ""}
                onChange={formik.handleChange}
                readOnly={field?.["readonly"]}
                className={formik.values[field?.["name"]] && "value"}
              />
            )}
            {/* <div style={{ width: 0, minHeight: "24px", border: "1px solid" }} /> */}
          </div>
        );
      })}
    </div>
  );
};

export default DynamicForm;
